import Popper from 'popper.js'
import { checkStatus, parseJSON } from '../../js/modules/helper-functions'

export const settings = {
  selector: '.js-extranet-toolbar',
  toggleBtn: '.js-extranet-toolbar-toggle',
  popperEl: '.js-extranet-toolbar-popper',
  loginForm: '.js-extranet-toolbar-login-form',
  popper: null
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  initPopper( element )
  const form = element.querySelector( settings.loginForm )
  if ( form ) {
    initForm( form )
  }
}

/**
 * Initialize extranet login form.
 *
 * @param {DOMNode} formEl
 */
function initForm( formEl ) {
  formEl.addEventListener( 'submit', ( event ) => {
    event.preventDefault()
    toggleSubmitDisable( formEl )
    const username = formEl.querySelector( 'input[name="username"]' ).value
    const password = formEl.querySelector( 'input[name="password"]' ).value
    handleLogin( username, password, formEl )
  })
}

/**
 * Toggle the forms submit buttons disabled state.
 *
 * @param {DOMNode} formEl
 * @return {boolean}
 */
function toggleSubmitDisable( formEl ) {
  const submit = formEl.querySelector( 'input[type="submit"]' )
  const disabled = submit.getAttribute( 'disabled' )
  if ( disabled ) {
    submit.removeAttribute( 'disabled' )
    return false
  } else {
    submit.setAttribute( 'disabled', true )
    return true
  }
}

/**
 * Handle login form submit.
 *
 * @param {string} username
 * @param {string} password
 */
function handleLogin( username, password, formEl ) {
  const endpoint = `${window.extranet.link.url}/wp-json/sponda-oauth/v1/user-credentials/`
  fetch( endpoint, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      username: username,
      password: password
    })
  })
    .then( checkStatus )
    .then( parseJSON )
    .then(( json ) => {
      toggleSubmitDisable( formEl )
      if ( json.success ) {
        window.location.href = json.redirect
      } else {
        handleLoginError( formEl, json.message )
      }
    })
    .catch(( error ) => {
      toggleSubmitDisable( formEl )
      handleLoginError( formEl, error.response.message )
    })
}

/**
 * Handle errors with login by appending the error
 * message to the UI.
 *
 * @param {DOMNode} formEl
 * @param {string} errorMessage
 */
function handleLoginError( formEl, errorMessage ) {
  const errorEl = formEl.querySelector( '.error' )
  if ( errorMessage ) {
    errorEl.innerText = errorMessage
  } else {
    errorEl.innerText = ''
  }
}

/**
 * Init tooltips.
 *
 * @param {DOMNode} element
 */
function initPopper( element ) {
  const popperEl = element.querySelector( settings.popperEl )
  const toggle = element.querySelector( settings.toggleBtn )
  // Toggle popper on click.
  toggle.addEventListener( 'click', () => {
    togglePopper( popperEl, toggle, element )
  })
  // Close with ESC-key.
  window.addEventListener( 'keyup', ( e ) => {
    if ( e.keyCode === 27 && settings.popper !== null ) {
      togglePopper( popperEl, toggle, element )
    }
  })
}

/**
 * Function either creates the Popper instance
 * if it doesn't already exist or removes it
 * otherwise.
 *
 * @param {DOMNode} popperEl
 * @param {DOMNode} toggleEl
 * @param {DOMNode} parentEl
 */
function togglePopper( popperEl, toggleEl, parentEl ) {
  if ( settings.popper === null ) {
    const popper = new Popper( toggleEl, popperEl, {
      placement: 'bottom',
      positionFixed: true,
      modifiers: {
        flip: {
          enabled: false
        }
      }
    })
    // setTimeout( popper.update, 50 )
    parentEl.classList.add( 'popper-active' )
    settings.popper = popper
  } else {
    parentEl.classList.remove( 'popper-active' )
    settings.popper.destroy()
    settings.popper = null
  }
}
